import React from 'react';
import MenuGame from './MenuGame';
import './App.css';

function App() {
  return (
    <div className="App">
      <MenuGame/>
    </div>
  );
}

export default App;
